export default __webpack_public_path__ + "static/media/how_to_play.8b081ea1.svg";